var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33332 18.3335V12.8585M9.99999 9.16683H10.0083M9.99999 5.8335H10.0083M11.6667 12.8585V18.3335M12.5 13.3335C11.7788 12.7926 10.9015 12.5002 9.99999 12.5002C9.09845 12.5002 8.22122 12.7926 7.49999 13.3335M13.3333 9.16683H13.3417M13.3333 5.8335H13.3417M6.66666 9.16683H6.67499M6.66666 5.8335H6.67499",
    stroke: "#2E2C27",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.66675H4.99999C4.07952 1.66675 3.33333 2.41294 3.33333 3.33341V16.6667C3.33333 17.5872 4.07952 18.3334 4.99999 18.3334H15C15.9205 18.3334 16.6667 17.5872 16.6667 16.6667V3.33341C16.6667 2.41294 15.9205 1.66675 15 1.66675Z",
    stroke: "#2E2C27",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.a13c677dc426f4033dfd166529f4cf48.svg";
export { ForwardRef as ReactComponent };